import type { ComponentType, ReactNode } from 'react';
import { Link } from '@tanstack/react-router';

/**
 * Navegação para as telas de versão de entrega.
 *
 * Mesmo motivo de `features/tickets/navigation.tsx`: o `to` do TanStack Router
 * é tipado contra a árvore registrada em `app/router.tsx`, e este módulo é
 * compilado antes de a rota existir lá. A conversão de tipo fica concentrada
 * aqui, num arquivo só.
 */

export const CAMINHO_ENTREGAS = '/entregas';
export const CAMINHO_ENTREGA = '/entregas/$releaseId';

interface PropsDeLink {
  to: string;
  params?: Record<string, string>;
  className?: string;
  title?: string;
  children: ReactNode;
}

const LinkDeRota = Link as unknown as ComponentType<PropsDeLink>;

export function LinkDaEntrega({
  releaseId,
  className,
  title,
  children,
}: {
  releaseId: string;
  className?: string;
  title?: string;
  children: ReactNode;
}) {
  return (
    <LinkDeRota
      to={CAMINHO_ENTREGA}
      params={{ releaseId }}
      className={className}
      title={title}
    >
      {children}
    </LinkDeRota>
  );
}

export function LinkDaListaDeEntregas({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  return (
    <LinkDeRota to={CAMINHO_ENTREGAS} className={className}>
      {children}
    </LinkDeRota>
  );
}
